<template>
    <div id="crisisScreen">
        <b-modal id="crisis-modal" size="lg" static role="dialog" aria-hidden="true" hide-footer hide-header @hidden="noProceed()">
            <div id="crisis-modal-body">
                <h2>North Coast Resource Hub - Crisis Screening</h2>
                <p id="crisis-modal-question">
                    Do you need urgent or immediate help?
                    <br />
                    <span class="es-translation">Necesitas ayuda urgente o inmediata?</span>
                </p>
                <p id="crisis-911">
                    If you have a life-threatening emergency, please call 9-1-1
                    <br />
                    <span class="es-translation">Si estas en una situación peligrosa, por favor llama al 9-1-1</span>
                </p>
                <button type="button" class="btn btn-primary btn-block crisis-button" @click="yesCrisis()">
                    Yes, show me crisis services
                    <br />
                    <span class="es-translation">Si, muéstrame servicios de crisis</span>
                </button>
                <button type="button" class="btn btn-secondary btn-block crisis-button" @click="noProceed()">
                    No, proceed to homepage
                    <br />
                    <span class="es-translation">No, procede a la página principal</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "CrisisScreening",
        data(){
            return {
                crisisAsked: this.$store.state.crisisAsked
            }
        },
        mounted(){
            if(!this.crisisAsked){
                this.$bvModal.show("crisis-modal")
            }
        },
        methods: {
            yesCrisis(){
                this.$emit("user-in-crisis")
                this.$bvModal.hide("crisis-modal")
                this.crisisAsked = true
                this.$store.commit("setCrisisAsked", true)
            },
            noProceed(){
                this.$bvModal.hide("crisis-modal")
                this.$store.commit("setCrisisAsked", true)
            }
        }
    }
</script>

<style scoped lang="scss">
    #crisis-modal-body {
        text-align: center;
    }
    #crisis-modal-body > h2 {
        font-size: 1.5rem;
    }
    #crisis-modal-question {
        font-weight: bold;
        font-size: 1.5rem;
        line-height: 1;
        & > .es-translation {
            font-size: 1.3rem;
            font-style: italic;
          }
    }

    #crisis-911 {
        line-height: 1.1;
    }

    button.crisis-button {
        line-height: 1;
    }

    .es-translation {
        font-size: .95rem;
        font-style: italic;
    }
</style>